import { useState } from 'react'
import './App.css'
import Header from './components/Header'
import AddPlantForm from './components/AddPlantForm'
import FilterBar from './components/FilterBar'
import PlantList from './components/PlantList'
import PlantDetailModal from './components/PlantDetailModal'

function App() {

  function checkNeedsWater(plant) {
  const today = new Date();
  const lastWateredDate = new Date(plant.lastWatered);
  const diffTime = today - lastWateredDate;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
  return diffDays >= plant.frequencyDays;
}

  const [plants, setPlants] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [selectedPlant, setSelectedPlant] = useState(null);
  const [currentFilter, setCurrentFilter] = useState("all");


  function toggleAddForm() {
    setIsFormOpen(!isFormOpen);
  }

  function handleAddPlant (newPlant) {
    const plantToAdd = {
      ...newPlant,
      id: Date.now(),
    lastWatered: new Date().toISOString().split('T')[0],
    careHistory: [new Date().toISOString().split('T')[0]]
  };
  setPlants(prevPlants => [...prevPlants, plantToAdd])
  }

  function handleFilterChange(filterValue) {
    setCurrentFilter(filterValue);
  }

  function handleOpenModal (plant) {
    setSelectedPlant(plant)
  }

  function handleCloseModal () {
    setSelectedPlant(null)  
  }

function handleWaterPlant(plantId) {
  const today = new Date().toISOString().split('T')[0];
  
  setPlants(prevPlants => prevPlants.map(plant => {
    if (plant.id === plantId) {
      return {
        ...plant,
        lastWatered: today,
        careHistory: [...plant.careHistory, today]
      };
    }
    return plant;
  }));
}

  function handleDeletePlant(plantId) {
    setPlants(prevPlants => prevPlants.filter(plant => plant.id !== plantId));
  }


  const totalPlants = plants.length;
  

const filteredPlants = plants.filter(plant => {
  if (currentFilter === "all") return true;
  if (currentFilter === "needs-water") return checkNeedsWater(plant);
  if (currentFilter === "healthy") return !checkNeedsWater(plant);
  return true;
});

const needsWaterCount = plants.filter(checkNeedsWater).length;
  
  return (
    <div className="app">
      <Header
      totalPlants={totalPlants}
      needsWaterCount={needsWaterCount} 
      />
      
      <main className="main-content">
        <AddPlantForm 
        isOpen={isFormOpen}
        onToggle={toggleAddForm}
        onAddPlant={handleAddPlant}
        />
        
        <PlantList
        plants={filteredPlants}
        onOpenModal={handleOpenModal}
        onWater={handleWaterPlant}
        onDelete={handleDeletePlant}
        currentFilter={currentFilter}
        />
      </main>

      <FilterBar 
      currentFilter={currentFilter}
      onFilterChange={handleFilterChange}
      />

      <PlantDetailModal 
      plant={selectedPlant}
      onClose={handleCloseModal}
      />
    </div>
  )
}

export default App